
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12333',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12333",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.467",
  "data-fetching-client": "static-1.9684",
  "foundations-components": "static-1.7972",
  "foundations-components-legacy": "static-1.997",
  "foundations-theming": "static-1.4436",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8030",
  "hub-http-shared-msw-handlers": "static-1.10011",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11489",
  "I18n": "static-7.1631",
  "jasmine-runner": "static-1.6480",
  "marketplace-storefront-base": "static-1.12394",
  "quartz": "static-1.7054",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16688",
  "reactive-variable-buffer-atom": "static-1.2875",
  "reporting-testing-lib": "static-1.9568",
  "settings-ui-lib": "static-1.12537",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7173",
  "ui-addon-i18n": "static-1.11165",
  "ui-addon-react-router-dom": "static-1.9558",
  "unified-auth": "static-1.513",
  "unified-auth-core-lib": "static-1.795",
  "usage-tracker": "static-1.7362",
  "usage-tracker-core": "static-1.7212",
  "customer-data-property-utils": "static-1.8107",
  "hub-http": "static-1.6238",
  "integrations-lib": "static-1.16212",
  "marketplace-ui-common": "static-1.19792",
  "property-management-iframe": "static-1.13224",
  "quartz-config": "static-1.832",
  "quartz-core": "static-1.6273",
  "quartz-routing": "static-1.484",
  "quick-fetch": "static-1.3928",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4669",
  "ts-schema": "static-1.4091",
  "ui-universal-auth": "static-1.8999",
  "UIComponents": "static-3.8435",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3411",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3331",
  "quartz-webpack": "static-1.3278",
  "bend-plugin-quartz-routing": "static-1.132",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4241",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4884",
  "foundations-theming-specialty": "static-1.2152",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9441",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5356",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1997",
  "ui-fonts": "static-1.751",
  "ui-images": "static-2.1159",
  "bend-plugin-foundations-theming": "static-1.2919",
  "foundations-theming-base": "static-1.3421",
  "stylex": "static-1.33",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3141",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4344",
  "ai-components-ui-library": "static-1.9031",
  "ai-rendering-library": "static-1.10244",
  "chirp-fetch": "static-1.1904",
  "connections-embed-lib": "static-1.1022",
  "copilot-toolkit": "static-1.11184",
  "feedback-loader": "static-1.29330",
  "laboratory-lib": "static-3.7172",
  "marketplace-embed": "static-1.22150",
  "marketplace-ui-details": "static-1.9688",
  "marketplace-ui-reviews": "static-1.19748",
  "marketplace-ui-tracking": "static-1.13963",
  "sanitize-text": "static-1.8158",
  "ui-addon-video-player": "static-1.8719",
  "usage-tracker-multi": "static-1.5776",
  "usage-tracker-session-replay": "static-1.5048",
  "wootric-nps": "static-1.6991",
  "quartz-head": "static-1.719",
  "web-vitals": "static-1.6",
  "apollo-link-hub-http": "static-2.4668",
  "immer": "static-1.33",
  "immerable": "static-1.4170",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67635",
  "cssUtils": "static-1.797",
  "flux-actions": "static-1.340",
  "HubStyle": "static-2.11796",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10223",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10382",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7352",
  "icons": "static-2.650",
  "marketplace-ui-apps-core": "static-1.18325",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4532",
  "foundations-components-test-utils": "static-1.5455",
  "quartz-i18n": "static-1.729",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.299",
  "microsoft-drive-integration-lib": "static-1.429",
  "slack-ui-library": "static-1.10409",
  "fsm": "static-1.3747",
  "customer-data-objects": "static-1.7686",
  "property-translator": "static-1.5416",
  "hs-locale-management": "static-1.92",
  "frontend-preferences-client": "static-1.7944",
  "hs-promise-utils": "static-1.5607",
  "hubspot-apollo-client": "static-1.4896",
  "integrations-error-boundary-lib": "static-1.13627",
  "integrations-tracking-lib": "static-1.5618",
  "native-integrations-shared-strings": "static-1.7798",
  "reselect": "static-2.16",
  "sanitize": "static-1.4493",
  "superstore": "static-1.4778",
  "ui-shepherd-react": "static-3.10183",
  "ai-settings-ui-library": "static-1.7914",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4663",
  "immutable-less": "static-1.4670",
  "marketplace-ui-client-types": "static-1.17199",
  "nav-meta": "static-1.29732",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10264",
  "ui-addon-upgrades": "static-9.18022",
  "inbound-db-properties-service-client": "static-1.3857",
  "property-management-common": "static-1.5512",
  "ui-addon-iframeable": "static-1.9074",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.729",
  "quartz-test": "static-1.729",
  "quartz-tracking": "static-1.433",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.79",
  "bender-build-tools": "static-1.3215",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21409",
  "ContentUtils": "static-1.68424",
  "customer-data-objects-ui-components": "static-1.13045",
  "sassPrefix": "static-1.156",
  "breeze-onboarding-components": "static-1.69",
  "avatar-components": "static-1.2514",
  "customer-data-filters-ui": "static-1.39864",
  "customer-data-reference-ui-components": "static-1.13182",
  "embedded-academy-lib": "static-1.14401",
  "ExportDialog": "static-6.10403",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41359",
  "reporting-snowflake": "static-1.56253",
  "reporting-ui-components": "static-2.64906",
  "reporting-visualizations": "static-1.59711",
  "ui-addon-teams": "static-1.21580",
  "magpie-lib": "static-1.5561",
  "navigation-components": "static-1.18095",
  "magpie-types": "static-1.5021",
  "simple-logging-lib": "static-1.3067",
  "ai-studio-lib": "static-1.11672",
  "app-governance-lib": "static-1.1602",
  "developer-experience-shared-components": "static-1.10526",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8015",
  "ui-product-approvals": "static-1.28186",
  "ui-tool-access": "static-1.10164",
  "usage-based-billing-components-lib": "static-1.8992",
  "usage-tracker-anonymous": "static-1.5779",
  "usage-tracker-public": "static-1.7173",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3597",
  "persist-promise": "static-1.3715",
  "reference-resolvers": "static-1.8187",
  "ui-extensibility-client-types": "static-1.3939",
  "hubspot-apollo-cache": "static-1.355",
  "universal-page-editor-lib": "static-1.3030",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2838",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5089",
  "purchase-motions-components": "static-1.5937",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1558",
  "crm-component-utils": "static-1.39133",
  "crm-properties-common-lib": "static-1.5901",
  "customer-data-properties": "static-1.51620",
  "framework-data-schema-resolvers": "static-1.6901",
  "property-value-citations": "static-1.2234",
  "reference-resolvers-lite": "static-1.8111",
  "ui-business-units-lib": "static-1.9071",
  "navigation-messaging": "static-1.7422",
  "hubspotter-http-shared-msw-handlers": "static-1.10009",
  "cms-field-types": "static-1.4829",
  "content-icons-ui": "static-1.2232",
  "customer-data-ui-utilities": "static-1.9843",
  "events-data-lib": "static-1.239",
  "conversations-skeleton-state": "static-1.7263",
  "crm-message-bus": "static-1.43040",
  "customer-data-filters-ui-msw-helpers": "static-1.22299",
  "FormUrlGenerator": "static-2.4735",
  "framework-builder-read-service-client": "static-1.4016",
  "framework-data-schema-quick-fetch": "static-1.6806",
  "multi-account-reference-resolvers": "static-1.996",
  "onboarding-tours": "static-1.16647",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13742",
  "academy-common-lib": "static-1.13861",
  "content-assistance-lib": "static-1.7779",
  "dashboard-lib": "static-1.81608",
  "file-manager-components": "static-1.23678",
  "getting-started-shared-tasks": "static-1.18515",
  "hubspot-prosemirror": "static-1.18287",
  "hubspot-prosemirror-plugins": "static-1.18279",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19865",
  "share-with-third-party-component-lib": "static-1.8718",
  "ui-addon-draggable": "static-3.4779",
  "ui-asset-management-lib": "static-1.11060",
  "user-context": "static-1.5122",
  "growth-payments-core": "static-1.25439",
  "reporting-plugins": "static-1.10353",
  "reporting-reports": "static-1.67313",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.740",
  "nest": "static-1.244",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10643",
  "framework-listing-lib": "static-2.28766",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30760",
  "apps-service-types": "static-1.3894",
  "oauth-service-types": "static-1.4265",
  "ui-product-approvals-common": "static-1.81",
  "onboarding-scopes": "static-1.6478",
  "onboarding-tours-client": "static-1.4861",
  "platform-infra-nav-components": "static-1.7682",
  "subscription-experience-data-types": "static-1.14960",
  "crm-record-cards-service-types": "static-1.3608",
  "location-customization-utils-lib": "static-1.9322",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5940",
  "signup-constants": "static-1.18875",
  "signup-ui-url-generator": "static-2.8069",
  "trials-service-types": "static-1.3919",
  "card-properties-lib": "static-1.44247",
  "commerce-subscription-lib": "static-1.37180",
  "crm-actions": "static-1.6343",
  "crm-cards-sdk": "static-1.43649",
  "customer-data-properties-shared-msw-handlers": "static-1.9338",
  "customer-data-tracking": "static-1.6906",
  "hs-resources": "static-1.170",
  "pulse": "static-1.593",
  "calling-global-api": "static-1.64581",
  "calling-internal-common": "static-1.31319",
  "calling-lifecycle-internal": "static-1.65963",
  "calling-lifecycle-messages": "static-1.58257",
  "commerce-products-lib": "static-1.9643",
  "conditional-properties-service-client": "static-1.3808",
  "crm-links": "static-1.6311",
  "external-options-client-types": "static-1.4170",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4234",
  "meetings-icalendar-utils-lib": "static-1.648",
  "multi-currency-client-types": "static-1.3702",
  "object-builder-ui-client": "static-1.48812",
  "pipeline-validation-client-types": "static-1.3976",
  "smart-property-lib": "static-1.7179",
  "tiered-pricing": "static-1.1260",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11006",
  "crm-pipelines-api-client-types": "static-1.4150",
  "fdsr-migration-layer": "static-1.20",
  "react-dnd-compat": "static-1.4631",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.930",
  "growth-data-modal": "static-1.5456",
  "growth-onboarding-confetti": "static-1.3083",
  "growth-onboarding-next-action-utils": "static-1.1979",
  "onboarding-tours-utils": "static-1.713",
  "ui-shepherd-tracker": "static-1.7564",
  "academy-service-client": "static-1.3697",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39177",
  "FileManagerLib": "static-1.39318",
  "video-embed": "static-1.35830",
  "ui-coaching-tips": "static-1.28618",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11338",
  "video-data-lib": "static-1.34996",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8487",
  "payment-link-components": "static-1.23598",
  "ui-addon-emoji-picker": "static-1.9904",
  "EmailSignatureEditor": "static-1.24414",
  "viral-links-lib": "static-1.7083",
  "data-token-picker": "static-1.16439",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.243",
  "timezone-utils": "static-2.5261",
  "seat-types-lib": "static-1.54",
  "getting-started-shared-tasks-store": "static-1.17633",
  "ui-addon-opt": "static-4.8382",
  "campaign-roi-lib": "static-1.9182",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7342",
  "customer-data-views-management": "static-1.25501",
  "framework-data-table": "static-2.11958",
  "marketing-platform-lib": "static-1.6874",
  "nudge-client-utils": "static-1.2624",
  "nudge-custom-ui-functions": "static-1.1052",
  "app-users-service-client": "static-1.5614",
  "app-users-service-types": "static-1.5022",
  "mini-checkout-client": "static-1.26854",
  "onboarding-utils": "static-1.5370",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28603",
  "edison-service-client-types": "static-1.404",
  "crm_data": "static-4.92029",
  "customer-data-sidebar": "static-2.46075",
  "enrichment-properties-lib": "static-1.16297",
  "ui-addon-draggable-compat": "static-2.4273",
  "commerce-billing-lib": "static-1.19143",
  "commerce-shared-components-lib": "static-1.18593",
  "commerce-tools-ui-lib": "static-1.10431",
  "crm-fe-perf": "static-1.22920",
  "bend-plugin-pulse": "static-1.96",
  "directed-graph": "static-1.952",
  "event-emitter": "static-1.964",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31326",
  "shared-worker-versioning": "static-1.11053",
  "calling-usage-tracker": "static-1.6558",
  "voice-sms-access-library": "static-1.1058",
  "commerce-permissions": "static-1.786",
  "products-iframe-lib": "static-1.7993",
  "products-ui-components-shared-msw-handlers": "static-1.10393",
  "data-agent-kit": "static-1.223",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10094",
  "policy-lib": "static-1.6794",
  "react-tinymce": "static-1.55300",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10157",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54426",
  "tinymce-plugins": "static-1.57540",
  "tinymce-themes": "static-1.56396",
  "onboarding-data-sync-lib": "static-1.1985",
  "growth-onboarding-next-action-components": "static-1.2007",
  "user-context-client": "static-1.4629",
  "audio-components": "static-1.5941",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36829",
  "urlinator": "static-1.4553",
  "video-components": "static-1.13341",
  "outpost": "static-1.4198",
  "growth-onboarding-feedback-components": "static-1.6597",
  "content-media-composition-data-lib": "static-1.12383",
  "content-media-compositions": "static-2.16390",
  "media-bridge-lib": "static-1.18958",
  "commerce-tours-lib": "static-1.6137",
  "growth-onboarding-reliability": "static-1.5099",
  "sales-checkout-service-client": "static-1.3657",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21708",
  "sales-email-signature-service-client": "static-1.3859",
  "ts-utils-lib": "static-1.189",
  "breeze-engine-lib": "static-1.716",
  "crm-export-dialog": "static-1.6308",
  "crm-index-associations-lib": "static-1.6457",
  "crm-view-components": "static-1.317",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2381",
  "nudge-renderer-utils": "static-1.2700",
  "whisper-core-api": "static-1.6680",
  "InboxConnectUtils": "static-4.14870",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5593",
  "settings-content-modals": "static-1.46142",
  "crm_universal": "static-1.22039",
  "customer-data-email": "static-1.18066",
  "card-payment-highlight-lib": "static-1.37235",
  "card-subscription-highlight-lib": "static-1.39603",
  "commerce-contract-lib": "static-1.12143",
  "invoices-highlight-card-lib": "static-1.54793",
  "orders-highlight-card-lib": "static-1.21527",
  "products-highlight-card-lib": "static-1.17926",
  "quotes-highlight-card-lib": "static-1.72120",
  "crm-source-interpretation-lib": "static-1.5360",
  "utility-belt": "static-1.2551",
  "payments-enrollment-embed-lib": "static-1.22957",
  "stripe-embedded-components": "static-1.7538",
  "customer-data-rte": "static-1.33052",
  "cv-backend-services": "static-1.1553",
  "growth-onboarding-empty-states": "static-1.5765",
  "payments-post-enroll-local-storage-lib": "static-1.5125",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38210",
  "calling-orchestration-schema": "static-1.35835",
  "sales-views-client-types": "static-1.4275",
  "hub-http-contrib": "static-1.3059",
  "interframe": "static-3.4776",
  "tinymce-data": "static-1.40511",
  "ui-addon-sales-email": "static-1.5227",
  "layout-dnd-components": "static-1.12479",
  "layout-dnd-utils": "static-1.11454",
  "ui-brand-identity-lib": "static-1.15363",
  "NamespacedHubStyle": "static-2.9070",
  "meetings-connect-utils-lib": "static-1.7622",
  "social-insights-client-types": "static-1.22177",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4158",
  "checkout-sdk": "static-3.23697",
  "checkout-service-types": "static-1.3832",
  "company-details-components": "static-1.6212",
  "payment-method-components": "static-1.6922",
  "pricing-pages-ui-components": "static-1.14106",
  "quote-checkout-service-types": "static-1.3483",
  "upgrade-catalog-service-types": "static-1.3536",
  "access-control-lib": "static-1.10452",
  "EmailComponents": "static-1.54807",
  "EmailData": "static-1.53484",
  "redux-less": "static-2.9500",
  "sequences-lib": "static-1.8073",
  "ui-gdpr-components": "static-1.10367",
  "products-ui-components": "static-1.40161",
  "accounting-integrations-ui-components": "static-1.7094",
  "invoices-ui-lib": "static-1.54809",
  "commerce-products-api": "static-1.2323",
  "invoices-iframe-lib": "static-1.56867",
  "quotes-modal-lib": "static-1.102798",
  "quotes-ui-lib": "static-1.80841",
  "stripe-connect-js": "static-1.69",
  "draft-content-plugins": "static-1.28324",
  "ContentData": "static-1.68499",
  "layout-data-lib": "static-1.9779",
  "hub-http-rxjs": "static-1.804",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3955",
  "billing-payments-client-types": "static-1.4005",
  "react-performance-metrics-lib": "static-1.572",
  "account-and-billing-fintech-outages": "static-3.18614",
  "pricing-pages-api": "static-1.13971",
  "ContentComponents": "static-2.71380",
  "marketing-contacts-lib": "static-1.10110",
  "marketing-email-service-types": "static-1.1919",
  "messaging-editing-lib": "static-1.46336",
  "messaging-usage-based-billing-components-lib": "static-1.1198",
  "automation-ui-source-apps": "static-1.18950",
  "automation-ui-types": "static-1.19868",
  "messaging-types-lib": "static-1.46073",
  "onboarding-settings-client": "static-1.4521",
  "sequences-client-types-lib": "static-1.7930",
  "commerce-tax-lib": "static-1.543",
  "price-books-api": "static-1.811",
  "price-books-components": "static-1.869",
  "property-description-translator": "static-1.3860",
  "ramp-editor": "static-1.194",
  "commerce-analytics-service-client": "static-1.3645",
  "totals-ui-components": "static-1.23657",
  "SalesContentIndexUI": "static-3.9277",
  "advanced-menus-core": "static-1.15156",
  "advanced-menus-lib": "static-1.12094",
  "ui-memberships-settings-lib": "static-1.34103",
  "segments-query-core": "static-1.1435",
  "demographics-service-types": "static-1.1668",
  "eligibility-engine-service-types": "static-1.3200",
  "automation-ui-ubb": "static-1.5784",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7355",
  "data-token-views": "static-1.16420",
  "forms-utils-lib": "static-1.12620",
  "payments-embed-points-lib": "static-1.13075",
  "simple-menus-core": "static-1.15155",
  "simple-menus-lib": "static-1.16672",
  "videoconference-integration-components": "static-1.6846",
  "marketing-contacts-client": "static-1.7533",
  "automation-applications-service-types": "static-1.3524",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77178",
  "short-messages-app-service-client": "static-1.3984",
  "web-interactives-components": "static-1.13791",
  "web-interactives-data": "static-1.13792",
  "messaging-shared-utils-lib": "static-1.647",
  "messaging-user-info-utils-lib": "static-1.817",
  "email-portal-health-service-types": "static-1.994",
  "line-items-api": "static-1.723",
  "commerce-totals-service-types": "static-1.3830",
  "FireAlarmUi": "static-1.4524",
  "sales-templates-service-types-lib": "static-1.4181",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21804",
  "automation-ui-usage-tracking": "static-1.21267",
  "data-studio-ubb": "static-1.2786",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27078",
  "collaboration-sidebar": "static-1.57889",
  "content-management-data-lib": "static-1.5412",
  "copilot-plugins": "static-1.11157",
  "cta-picker": "static-1.36459",
  "customer-agent-discovery-components-lib": "static-1.3142",
  "editor-components": "static-1.13253",
  "editor-iframe-lib": "static-1.8427",
  "error-messaging-js": "static-1.5209",
  "FormsCommonComponents": "static-1.85910",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10662",
  "SharedLegalStrings": "static-1.1764",
  "smart-content-core": "static-1.42500",
  "smart-content-lib": "static-1.43153",
  "social-composer-lib": "static-1.59238",
  "structured-content-lib": "static-1.25248",
  "theme-previewer-lib": "static-1.53306",
  "tinymce-copilot": "static-1.16494",
  "xray-recommendation-lib": "static-1.7932",
  "automation-ui-routing": "static-1.21225",
  "sql-reporting-client-types": "static-1.5653",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42242",
  "campaigns-utils-lib": "static-1.3198",
  "reporting-enablement": "static-1.22997",
  "chatspot-widget-iframe": "static-1.21400",
  "collaboration-sidebar-common": "static-1.2686",
  "forms-ai-lib": "static-1.4346",
  "codemirror-dlb": "static-1.58737",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6448",
  "report-customization-components": "static-1.13227",
  "data-quality-ui-library": "static-1.13087",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.376",
  "reporting-insights-lib": "static-1.1808"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12333",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.467",
  "data-fetching-client": "/data-fetching-client/static-1.9684",
  "foundations-components": "/foundations-components/static-1.7972",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.997",
  "foundations-theming": "/foundations-theming/static-1.4436",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8030",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10011",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11489",
  "I18n": "/I18n/static-7.1631",
  "jasmine-runner": "/jasmine-runner/static-1.6480",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12394",
  "quartz": "/quartz/static-1.7054",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16688",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2875",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9568",
  "settings-ui-lib": "/settings-ui-lib/static-1.12537",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7173",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11165",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9558",
  "unified-auth": "/unified-auth/static-1.513",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.795",
  "usage-tracker": "/usage-tracker/static-1.7362",
  "usage-tracker-core": "/usage-tracker-core/static-1.7212",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8107",
  "hub-http": "/hub-http/static-1.6238",
  "integrations-lib": "/integrations-lib/static-1.16212",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19792",
  "property-management-iframe": "/property-management-iframe/static-1.13224",
  "quartz-config": "/quartz-config/static-1.832",
  "quartz-core": "/quartz-core/static-1.6273",
  "quartz-routing": "/quartz-routing/static-1.484",
  "quick-fetch": "/quick-fetch/static-1.3928",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4669",
  "ts-schema": "/ts-schema/static-1.4091",
  "ui-universal-auth": "/ui-universal-auth/static-1.8999",
  "UIComponents": "/UIComponents/static-3.8435",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3411",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3331",
  "quartz-webpack": "/quartz-webpack/static-1.3278",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.132",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4241",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4884",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2152",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9441",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5356",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1997",
  "ui-fonts": "/ui-fonts/static-1.751",
  "ui-images": "/ui-images/static-2.1159",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2919",
  "foundations-theming-base": "/foundations-theming-base/static-1.3421",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3141",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4344",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9031",
  "ai-rendering-library": "/ai-rendering-library/static-1.10244",
  "chirp-fetch": "/chirp-fetch/static-1.1904",
  "connections-embed-lib": "/connections-embed-lib/static-1.1022",
  "copilot-toolkit": "/copilot-toolkit/static-1.11184",
  "feedback-loader": "/feedback-loader/static-1.29330",
  "laboratory-lib": "/laboratory-lib/static-3.7172",
  "marketplace-embed": "/marketplace-embed/static-1.22150",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9688",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19748",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13963",
  "sanitize-text": "/sanitize-text/static-1.8158",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8719",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5776",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5048",
  "wootric-nps": "/wootric-nps/static-1.6991",
  "quartz-head": "/quartz-head/static-1.719",
  "web-vitals": "/web-vitals/static-1.6",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4668",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4170",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67635",
  "cssUtils": "/cssUtils/static-1.797",
  "flux-actions": "/flux-actions/static-1.340",
  "HubStyle": "/HubStyle/static-2.11796",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10223",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10382",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7352",
  "icons": "/icons/static-2.650",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18325",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4532",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5455",
  "quartz-i18n": "/quartz-i18n/static-1.729",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.299",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.429",
  "slack-ui-library": "/slack-ui-library/static-1.10409",
  "fsm": "/fsm/static-1.3747",
  "customer-data-objects": "/customer-data-objects/static-1.7686",
  "property-translator": "/property-translator/static-1.5416",
  "hs-locale-management": "/hs-locale-management/static-1.92",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7944",
  "hs-promise-utils": "/hs-promise-utils/static-1.5607",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4896",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13627",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5618",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7798",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4493",
  "superstore": "/superstore/static-1.4778",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10183",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7914",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4663",
  "immutable-less": "/immutable-less/static-1.4670",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17199",
  "nav-meta": "/nav-meta/static-1.29732",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10264",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18022",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3857",
  "property-management-common": "/property-management-common/static-1.5512",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9074",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.729",
  "quartz-test": "/quartz-test/static-1.729",
  "quartz-tracking": "/quartz-tracking/static-1.433",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.79",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21409",
  "ContentUtils": "/ContentUtils/static-1.68424",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13045",
  "sassPrefix": "/sassPrefix/static-1.156",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.69",
  "avatar-components": "/avatar-components/static-1.2514",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39864",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13182",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14401",
  "ExportDialog": "/ExportDialog/static-6.10403",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41359",
  "reporting-snowflake": "/reporting-snowflake/static-1.56253",
  "reporting-ui-components": "/reporting-ui-components/static-2.64906",
  "reporting-visualizations": "/reporting-visualizations/static-1.59711",
  "ui-addon-teams": "/ui-addon-teams/static-1.21580",
  "magpie-lib": "/magpie-lib/static-1.5561",
  "navigation-components": "/navigation-components/static-1.18095",
  "magpie-types": "/magpie-types/static-1.5021",
  "simple-logging-lib": "/simple-logging-lib/static-1.3067",
  "ai-studio-lib": "/ai-studio-lib/static-1.11672",
  "app-governance-lib": "/app-governance-lib/static-1.1602",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10526",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8015",
  "ui-product-approvals": "/ui-product-approvals/static-1.28186",
  "ui-tool-access": "/ui-tool-access/static-1.10164",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8992",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5779",
  "usage-tracker-public": "/usage-tracker-public/static-1.7173",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3597",
  "persist-promise": "/persist-promise/static-1.3715",
  "reference-resolvers": "/reference-resolvers/static-1.8187",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3939",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.355",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3030",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2838",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5089",
  "purchase-motions-components": "/purchase-motions-components/static-1.5937",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1558",
  "crm-component-utils": "/crm-component-utils/static-1.39133",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5901",
  "customer-data-properties": "/customer-data-properties/static-1.51620",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6901",
  "property-value-citations": "/property-value-citations/static-1.2234",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8111",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9071",
  "navigation-messaging": "/navigation-messaging/static-1.7422",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10009",
  "cms-field-types": "/cms-field-types/static-1.4829",
  "content-icons-ui": "/content-icons-ui/static-1.2232",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9843",
  "events-data-lib": "/events-data-lib/static-1.239",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7263",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22299",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4735",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4016",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6806",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.996",
  "onboarding-tours": "/onboarding-tours/static-1.16647",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13742",
  "academy-common-lib": "/academy-common-lib/static-1.13861",
  "content-assistance-lib": "/content-assistance-lib/static-1.7779",
  "dashboard-lib": "/dashboard-lib/static-1.81608",
  "file-manager-components": "/file-manager-components/static-1.23678",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18515",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18287",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18279",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19865",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8718",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4779",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11060",
  "user-context": "/user-context/static-1.5122",
  "growth-payments-core": "/growth-payments-core/static-1.25439",
  "reporting-plugins": "/reporting-plugins/static-1.10353",
  "reporting-reports": "/reporting-reports/static-1.67313",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.740",
  "nest": "/nest/static-1.244",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10643",
  "framework-listing-lib": "/framework-listing-lib/static-2.28766",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30760",
  "apps-service-types": "/apps-service-types/static-1.3894",
  "oauth-service-types": "/oauth-service-types/static-1.4265",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.81",
  "onboarding-scopes": "/onboarding-scopes/static-1.6478",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4861",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7682",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14960",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3608",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9322",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5940",
  "signup-constants": "/signup-constants/static-1.18875",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8069",
  "trials-service-types": "/trials-service-types/static-1.3919",
  "card-properties-lib": "/card-properties-lib/static-1.44247",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37180",
  "crm-actions": "/crm-actions/static-1.6343",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43649",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9338",
  "customer-data-tracking": "/customer-data-tracking/static-1.6906",
  "hs-resources": "/hs-resources/static-1.170",
  "pulse": "/pulse/static-1.593",
  "calling-global-api": "/calling-global-api/static-1.64581",
  "calling-internal-common": "/calling-internal-common/static-1.31319",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65963",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58257",
  "commerce-products-lib": "/commerce-products-lib/static-1.9643",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3808",
  "crm-links": "/crm-links/static-1.6311",
  "external-options-client-types": "/external-options-client-types/static-1.4170",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4234",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.648",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3702",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48812",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3976",
  "smart-property-lib": "/smart-property-lib/static-1.7179",
  "tiered-pricing": "/tiered-pricing/static-1.1260",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11006",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4150",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.20",
  "react-dnd-compat": "/react-dnd-compat/static-1.4631",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.930",
  "growth-data-modal": "/growth-data-modal/static-1.5456",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3083",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1979",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.713",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7564",
  "academy-service-client": "/academy-service-client/static-1.3697",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39177",
  "FileManagerLib": "/FileManagerLib/static-1.39318",
  "video-embed": "/video-embed/static-1.35830",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28618",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11338",
  "video-data-lib": "/video-data-lib/static-1.34996",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8487",
  "payment-link-components": "/payment-link-components/static-1.23598",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9904",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24414",
  "viral-links-lib": "/viral-links-lib/static-1.7083",
  "data-token-picker": "/data-token-picker/static-1.16439",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.243",
  "timezone-utils": "/timezone-utils/static-2.5261",
  "seat-types-lib": "/seat-types-lib/static-1.54",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17633",
  "ui-addon-opt": "/ui-addon-opt/static-4.8382",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9182",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7342",
  "customer-data-views-management": "/customer-data-views-management/static-1.25501",
  "framework-data-table": "/framework-data-table/static-2.11958",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6874",
  "nudge-client-utils": "/nudge-client-utils/static-1.2624",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1052",
  "app-users-service-client": "/app-users-service-client/static-1.5614",
  "app-users-service-types": "/app-users-service-types/static-1.5022",
  "mini-checkout-client": "/mini-checkout-client/static-1.26854",
  "onboarding-utils": "/onboarding-utils/static-1.5370",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28603",
  "edison-service-client-types": "/edison-service-client-types/static-1.404",
  "crm_data": "/crm_data/static-4.92029",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46075",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16297",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4273",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19143",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18593",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10431",
  "crm-fe-perf": "/crm-fe-perf/static-1.22920",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.96",
  "directed-graph": "/directed-graph/static-1.952",
  "event-emitter": "/event-emitter/static-1.964",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31326",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11053",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6558",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1058",
  "commerce-permissions": "/commerce-permissions/static-1.786",
  "products-iframe-lib": "/products-iframe-lib/static-1.7993",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10393",
  "data-agent-kit": "/data-agent-kit/static-1.223",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10094",
  "policy-lib": "/policy-lib/static-1.6794",
  "react-tinymce": "/react-tinymce/static-1.55300",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10157",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54426",
  "tinymce-plugins": "/tinymce-plugins/static-1.57540",
  "tinymce-themes": "/tinymce-themes/static-1.56396",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1985",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2007",
  "user-context-client": "/user-context-client/static-1.4629",
  "audio-components": "/audio-components/static-1.5941",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36829",
  "urlinator": "/urlinator/static-1.4553",
  "video-components": "/video-components/static-1.13341",
  "outpost": "/outpost/static-1.4198",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6597",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12383",
  "content-media-compositions": "/content-media-compositions/static-2.16390",
  "media-bridge-lib": "/media-bridge-lib/static-1.18958",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6137",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5099",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3657",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21708",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3859",
  "ts-utils-lib": "/ts-utils-lib/static-1.189",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.716",
  "crm-export-dialog": "/crm-export-dialog/static-1.6308",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6457",
  "crm-view-components": "/crm-view-components/static-1.317",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2381",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2700",
  "whisper-core-api": "/whisper-core-api/static-1.6680",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14870",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5593",
  "settings-content-modals": "/settings-content-modals/static-1.46142",
  "crm_universal": "/crm_universal/static-1.22039",
  "customer-data-email": "/customer-data-email/static-1.18066",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37235",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39603",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12143",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54793",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21527",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17926",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72120",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5360",
  "utility-belt": "/utility-belt/static-1.2551",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22957",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7538",
  "customer-data-rte": "/customer-data-rte/static-1.33052",
  "cv-backend-services": "/cv-backend-services/static-1.1553",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5765",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5125",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38210",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35835",
  "sales-views-client-types": "/sales-views-client-types/static-1.4275",
  "hub-http-contrib": "/hub-http-contrib/static-1.3059",
  "interframe": "/interframe/static-3.4776",
  "tinymce-data": "/tinymce-data/static-1.40511",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5227",
  "layout-dnd-components": "/layout-dnd-components/static-1.12479",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11454",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15363",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9070",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7622",
  "social-insights-client-types": "/social-insights-client-types/static-1.22177",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4158",
  "checkout-sdk": "/checkout-sdk/static-3.23697",
  "checkout-service-types": "/checkout-service-types/static-1.3832",
  "company-details-components": "/company-details-components/static-1.6212",
  "payment-method-components": "/payment-method-components/static-1.6922",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14106",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3483",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3536",
  "access-control-lib": "/access-control-lib/static-1.10452",
  "EmailComponents": "/EmailComponents/static-1.54807",
  "EmailData": "/EmailData/static-1.53484",
  "redux-less": "/redux-less/static-2.9500",
  "sequences-lib": "/sequences-lib/static-1.8073",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10367",
  "products-ui-components": "/products-ui-components/static-1.40161",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7094",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54809",
  "commerce-products-api": "/commerce-products-api/static-1.2323",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56867",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102798",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80841",
  "stripe-connect-js": "/stripe-connect-js/static-1.69",
  "draft-content-plugins": "/draft-content-plugins/static-1.28324",
  "ContentData": "/ContentData/static-1.68499",
  "layout-data-lib": "/layout-data-lib/static-1.9779",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.804",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3955",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4005",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.572",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18614",
  "pricing-pages-api": "/pricing-pages-api/static-1.13971",
  "ContentComponents": "/ContentComponents/static-2.71380",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10110",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1919",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46336",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1198",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18950",
  "automation-ui-types": "/automation-ui-types/static-1.19868",
  "messaging-types-lib": "/messaging-types-lib/static-1.46073",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4521",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7930",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.543",
  "price-books-api": "/price-books-api/static-1.811",
  "price-books-components": "/price-books-components/static-1.869",
  "property-description-translator": "/property-description-translator/static-1.3860",
  "ramp-editor": "/ramp-editor/static-1.194",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3645",
  "totals-ui-components": "/totals-ui-components/static-1.23657",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9277",
  "advanced-menus-core": "/advanced-menus-core/static-1.15156",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12094",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34103",
  "segments-query-core": "/segments-query-core/static-1.1435",
  "demographics-service-types": "/demographics-service-types/static-1.1668",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3200",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5784",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7355",
  "data-token-views": "/data-token-views/static-1.16420",
  "forms-utils-lib": "/forms-utils-lib/static-1.12620",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13075",
  "simple-menus-core": "/simple-menus-core/static-1.15155",
  "simple-menus-lib": "/simple-menus-lib/static-1.16672",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6846",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7533",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3524",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77178",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3984",
  "web-interactives-components": "/web-interactives-components/static-1.13791",
  "web-interactives-data": "/web-interactives-data/static-1.13792",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.647",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.817",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.994",
  "line-items-api": "/line-items-api/static-1.723",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3830",
  "FireAlarmUi": "/FireAlarmUi/static-1.4524",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4181",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21804",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21267",
  "data-studio-ubb": "/data-studio-ubb/static-1.2786",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27078",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57889",
  "content-management-data-lib": "/content-management-data-lib/static-1.5412",
  "copilot-plugins": "/copilot-plugins/static-1.11157",
  "cta-picker": "/cta-picker/static-1.36459",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3142",
  "editor-components": "/editor-components/static-1.13253",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8427",
  "error-messaging-js": "/error-messaging-js/static-1.5209",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85910",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10662",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1764",
  "smart-content-core": "/smart-content-core/static-1.42500",
  "smart-content-lib": "/smart-content-lib/static-1.43153",
  "social-composer-lib": "/social-composer-lib/static-1.59238",
  "structured-content-lib": "/structured-content-lib/static-1.25248",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53306",
  "tinymce-copilot": "/tinymce-copilot/static-1.16494",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7932",
  "automation-ui-routing": "/automation-ui-routing/static-1.21225",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5653",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42242",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3198",
  "reporting-enablement": "/reporting-enablement/static-1.22997",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21400",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2686",
  "forms-ai-lib": "/forms-ai-lib/static-1.4346",
  "codemirror-dlb": "/codemirror-dlb/static-1.58737",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6448",
  "report-customization-components": "/report-customization-components/static-1.13227",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13087",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.376",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1808"
}
};
